import { observer } from "mobx-react-lite";
import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Route, RouteComponentProps, Switch } from "react-router-dom";
import { toast } from "react-toastify";
import { translationHookOptions } from "../app/localization/localization";
import { RootStoreContext } from "../app/stores/rootStore";
import Loader from "../components/common/Loader";
import PodiumSpeakerPage from "../views/PodiumSpeakerPage";
import PodiumSpeakersListPage from "../views/PodiumSpeakersListPage";

interface IPodiumParams {
  tenant: string;
  meetingId: string;
  accept:string;
}

const PodiumLayout: React.FC<RouteComponentProps<IPodiumParams>> = ({
  history,
  match,
}) => {
  const rootStore = useContext(RootStoreContext);
  const { attendingMeeting } = rootStore.playerStore;
  const {
    currentTenant,
    alreadyCheckedMeetingAttendance,
    attendMeeting,
    leaveMeeting,
  } = rootStore.tenantStore;
  const [t] = useTranslation(["podium"], translationHookOptions);
  let preview=false;
  if( match.params.accept !==undefined){
     
    preview=true;

  
  }
// console.log("accept ="+match.params.accept)
  useEffect(() => {
    document.body.classList.remove("NavbarShift");
    const meetingId = parseInt(match.params.meetingId);
    if (alreadyCheckedMeetingAttendance && preview !==true) {
     
      if (!attendingMeeting) {
        let errorUrl = currentTenant ? `${currentTenant.path}` : "/";
        attendMeeting(meetingId).then((result) => {
          if (!result) {
            toast.error(t("podium_not_found"));
            history.push(errorUrl);
          }
        });
      } else if (attendingMeeting.id !== meetingId) {
        leaveMeeting(attendingMeeting.id, false);
      }
    }
  }, [
    match.params.meetingId,
    alreadyCheckedMeetingAttendance,
    attendingMeeting,
    currentTenant,
    attendMeeting,
    leaveMeeting,
    t,
    history, 
    preview
  ]);
 
  if (!attendingMeeting && preview===false) return <Loader />;

  return (
    <>
      <Switch>
      <Route
          exact
          path="/:tenant/meeting/:meetingId/podium/preview/:accept"

          component={PodiumSpeakersListPage}
        />
        <Route
          exact
          path="/:tenant/meeting/:meetingId/podium"
          component={PodiumSpeakersListPage}
        />
        
        <Route
          path="/:tenant/meeting/:meetingId/podium/:speakerId"
          component={PodiumSpeakerPage}
        />
      </Switch>
    </>
  );
};

export default observer(PodiumLayout);
